import { exists } from '@/helpers/utilities';

export let mixin = ({ node = null, config = {} } = {}) => {
    if (!node) return false;

    let state = {
        node,
        config,
    };

    let module = {
        createLookup() {
            state.lookup = {
                'ip-address': `.... IP ${jsHelpers.userIpAddress}`,
                timestamp: `[ SYS ] ....  ${jsHelpers.timestamp}`,
            };
        },
        writeMetaText() {
            let key = state.node.dataset.textContent;
            if (!key) return;
            let text = state.lookup[key];

            let textSlot = state.node.querySelector('span');
            textSlot.textContent = text;
        },
        init() {
            if (!exists(node)) return;
            this.createLookup();
            this.writeMetaText();
        },
    };

    return module.init();
};

export default {
    init({ selector, config = {} }) {
        let selected = document.querySelectorAll(selector);
        if (!selected.length) return;

        return [...selected].map((node, index) => {
            return mixin({ node, config });
        });
    },
};
